require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-online-and-mobile-banking.json") })
        }
      }, "path---articles-online-and-mobile-banking");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-online-and-mobile-banking!./.cache/json/articles-online-and-mobile-banking.json
// module id = 1717
// module chunks = 231608221292675